import CryptoJS from 'crypto-js';
import { SECURITY_CONFIG } from '../config';

const SECRET_KEY = SECURITY_CONFIG.ENCRYPTION_SECRET_KEY;

export const encryptId = (id: string | number | null | undefined): string => {
  if (!id) return "";
  const ciphertext = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
  // Base64URL encoding (replace + with -, / with _, and remove padding =)
  return ciphertext.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const decryptId = (encrypted: string): string => {
  if (!encrypted) return "";
  try {
    // If it's a legacy URL encoded string (contains %), decode it first
    let base64 = encrypted;
    if (base64.includes('%')) {
      try {
        base64 = decodeURIComponent(base64);
      } catch (e) {
        return ""; // Tampered URI encoding
      }
    }
    
    // Convert Base64URL back to Base64
    base64 = base64.replace(/-/g, '+').replace(/_/g, '/');
    // Pad with = to make length a multiple of 4
    while (base64.length % 4) {
      base64 += '=';
    }
    
    const bytes = CryptoJS.AES.decrypt(base64, SECRET_KEY);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  } catch (e) {
    return "";
  }
};
